import React, {useRef, useEffect, useMemo} from 'react';
import DataGrid, {Column} from 'devextreme-react/data-grid';
import {Item as TabItem} from "devextreme-react/tab-panel";
import Form, {GroupItem, SimpleItem, Label, FormRef, EmptyItem} from "devextreme-react/form";
import ILangue from '../../models/ILangue';
import {FormListBase, FormListBaseTab, FormListBaseGrid, FormListBaseToolbar} from '../base';
import useCustomDataSource, {IFormBaseDataSourceOptions, Mode} from "../../hooks/useCustomDataSource";
import FormSysteme from '../../components/forms/form-systeme';
import useApi from '../../hooks/useApi';
import useLookUpBase from '../../components/selectbox/LookupBase';
import GestionActivites from '../gestion-activites/gestion-activites';

interface IConfigurationReservationProps {
    isModeSelection?: boolean,
}

export default function ConfigurationReservation({isModeSelection}: IConfigurationReservationProps) {
    const reservationFormDataSource = useCustomDataSource<any, any>({path: "langue", primaryKey: "idLangue"});
    const {setMainForm, selectedDataRow: selectedReservation, setIsFieldModifier, mode, setMode, setSelectedDataRow, isFieldModifier, onFieldDataChanged} = reservationFormDataSource;
    const formRef = useRef<FormRef>(null);
    const {editorOptions: activiteEditorOption, PopupGestion: PopupGestionActivite} = useLookUpBase({isModeModifier: mode !== Mode.Lecture, controllerName: 'activite', showClear: mode !== Mode.Lecture, showDropDown: isFieldModifier, width: '250px'});

    const {
        getData: getConfig,
    } = useApi('Configuration');

    useEffect(() => {
        try {
            const names = 'ACTIVER_DEPOT_AUTOMATIQUE,ACTIVER_DEPOT_AUTOMATIQUE_SITES_WEB,MONTANT_DEPOT_REQUIS,MONTANT_DEPOT_REQUIS2,MONTANT_DEPOT_REQUIS3,TRANCHE_ARRONDISSEMENT_DEPOT_REQUIS,NB_JOURS_POUR_DEPOT_REQUIS,SOURCE_DATE_DELAI,AFFICHER_NOTE_RESERVATION,AFFICHER_NO_MEMBRE_CONFIRMATION,CACHER_DATE_DEPART_CONFIRMATION,CACHER_FRAIS_SERVICE_CONF_RESER,CACHER_HEURES_ENTETE_CONFIRMATION,CACHER_PAIEMENTS_CONFIRMATION_RESERVATION,IMPRIMER_OCCUPANTS_RPT_CONF_RESERV,INCLURE_TAXES_PRIX_UNITAIRE_CONFIRMATION_RESERVATION,NOMBRE_COPIES_CONFIRMATION,NOMBRE_COPIES_FICHE_RESERVATION,ACTIVITE_RESERVATION_DEFAUT,DATE_DEBUT_ENVOI_SOMTAB,COULEUR_GROUPE_DETAIL_RESERVATION,COULEUR_GROUPE_ENTETE_RESERVATION,AFFICHER_DOCUMENT_RECU_RESERVATION,AFFICHER_DEVISE_RESERVATION,AFFICHER_CODE_CLIENT_LISTE_CLIENT,AFFICHER_NO_MEMBRE_CONFIRMATION,AFFICHER_INFO_MEMBRE_RECHERCHE_CLIENT,IMPRIMER_FICHE_RESERVATION,DECORTIQUER_AUTO_NOUVELLE_RESERVATION'
            getConfig({customPath: `Configuration/${names}/Config`})
                .then((result) => {
                    setSelectedDataRow((prev: any) => {
                        if (!result || typeof result !== "object")
                            return prev;
                        return {...prev, ...result}
                    })
                })
                .catch((err) => console.log(err))
        } catch (error) {
        }
    }, [])

    const typeDeCalculEditorOptions = useMemo(() => {
        return {
            items: ['Fixe', 'Pourcentage'],
            layout: 'horizontal'
        }
    }, []);
    const modeDepotEditorOptions = useMemo(() => {
        return {
            items: ['Global', 'Par personnes'],
            layout: 'horizontal'
        }
    }, []);
    const calculerSurEditorOptions = useMemo(() => {
        return {
            items: ['Montant avant taxes', 'Montant après taxes'],
            layout: 'horizontal'
        }
    }, []);
    const pourcentageEditorOptions = useMemo(() => {
        return {
            width: 150,
            format: "#,##0.##",
            inputAttr: {style: "text-align: right;"},
        }
    }, []);
    const trancheEditorOptions = useMemo(() => {
        return {
            width: 150,
            format: "#,##0",
            inputAttr: {style: "text-align: right;"},
        }
    }, []);
    const dateDelaiEditorOptions = useMemo(() => {
        return {
            items: ['Date de début du séjour', 'Date de création de la réservation'],
            layout: 'horizontal'
        }
    }, []);
    const spinEditorOptions = useMemo(() => {
        return {min: 1, max: 999, showSpinButtons: true, width: 60}
    }, []);
    const dateEnvoieEditorOptions = useMemo(() => {
        return {
            width: 250,
            displayFormat: "dd-MM-yyyy",
            useMaskBehavior: true
        }
    }, []);
    const colorEditorOptions = useMemo(() => {
        return {
            width: 250,
        }
    }, []);

    useEffect(() => {
        setMainForm(formRef.current?.instance());
    })

    useEffect(() => {
        if (mode !== Mode.Lecture) formRef.current?.instance().getEditor("description")?.focus();
    }, [mode])


    const onSelectionchanged = (item: any, e: string) => {
        setIsFieldModifier(true);
        setSelectedDataRow((prev: any) => {
            return {...prev, [e]: item.id}
        })
    }

    return (
        <FormListBase data={reservationFormDataSource} hideList={true}>
            {/* <FormListBaseGrid dataSource={reservationFormDataSource.dataSource} onFocusedRowChanged={() => { setIsModeModify(false) }}      >
        <Column key={"grid-col-description"} dataField={"description"} caption="Description" allowHiding={false} />
      </FormListBaseGrid> */}
            <FormListBaseToolbar removeBlocked={true} headerText={`${selectedReservation?.description || ''}`} sauvegarderOptions={{disabled: !isFieldModifier}} annulerOptions={{disabled: !isFieldModifier}} effacerOptions={{visible: false, disabled: !isFieldModifier}}/>
            {!isModeSelection || isModeSelection && mode !== Mode.Lecture
                ? <FormListBaseTab>
                    <TabItem title="Informations">
                        <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedReservation || {} as ILangue} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
                            <PopupGestionActivite onSelectionchanged={(i) => onSelectionchanged(i, 'idcategorieclient')}>
                                <GestionActivites isModeSelection={true}/>
                            </PopupGestionActivite>
                            <GroupItem caption='Dépôts requis sur réservations'>
                                <GroupItem colCount={3}>
                                    <SimpleItem key={"frm-ACTIVER_DEPOT_AUTOMATIQUE"} dataField={"ACTIVER_DEPOT_AUTOMATIQUE"} editorType='dxCheckBox'>
                                        <Label text='Activer le dépôt automatique'></Label>
                                    </SimpleItem>
                                    <SimpleItem key={"frm-ACTIVER_DEPOT_AUTOMATIQUE_SITES_WEB"} dataField={"ACTIVER_DEPOT_AUTOMATIQUE_SITES_WEB"} editorType='dxCheckBox'>
                                        <Label text='Activer le dépôt par les sites web'></Label>
                                    </SimpleItem>
                                    <EmptyItem></EmptyItem>
                                </GroupItem>
                                <SimpleItem key={"frm-typeCalcul"} dataField={"typeCalcul"} editorType='dxRadioGroup' editorOptions={typeDeCalculEditorOptions}>
                                    <Label text='Type de calcul pour le dépôt'></Label>
                                </SimpleItem>
                                <SimpleItem key={"frm-modeDepot"} dataField={"modeDepot"} editorType='dxRadioGroup' editorOptions={modeDepotEditorOptions}>
                                    <Label text='Mode de dépôt'></Label>
                                </SimpleItem>
                                <SimpleItem key={"frm-calculer"} dataField={"calculer"} editorType='dxRadioGroup' editorOptions={calculerSurEditorOptions}>
                                    <Label text='Calculer sur'></Label>
                                </SimpleItem>
                                <SimpleItem key={"frm-MONTANT_DEPOT_REQUIS"} dataField={"MONTANT_DEPOT_REQUIS"} editorType='dxNumberBox' editorOptions={pourcentageEditorOptions}>
                                    <Label text='Pourcentage requis'></Label>
                                </SimpleItem>
                                <SimpleItem key={"frm-MONTANT_DEPOT_REQUIS2"} dataField={"MONTANT_DEPOT_REQUIS2"} editorType='dxNumberBox' editorOptions={pourcentageEditorOptions}>
                                    <Label text='Pourcentage requis 2 '></Label>
                                </SimpleItem>
                                <SimpleItem key={"frm-MONTANT_DEPOT_REQUIS3"} dataField={"MONTANT_DEPOT_REQUIS3"} editorType='dxNumberBox' editorOptions={pourcentageEditorOptions}>
                                    <Label text='Pourcentage requis 3'></Label>
                                </SimpleItem>
                                <SimpleItem key={"frm-TRANCHE_ARRONDISSEMENT_DEPOT_REQUIS"} dataField={"TRANCHE_ARRONDISSEMENT_DEPOT_REQUIS"} editorType='dxNumberBox' editorOptions={trancheEditorOptions}>
                                    <Label text="Tranche d'arrondissement des dépôts requis"></Label>
                                </SimpleItem>
                                <SimpleItem key={"frm-NB_JOURS_POUR_DEPOT_REQUIS"} dataField={"NB_JOURS_POUR_DEPOT_REQUIS"} editorType='dxNumberBox' editorOptions={trancheEditorOptions}>
                                    <Label text="Nombre de jours pour effectuer le dépôt requis"></Label>
                                </SimpleItem>
                                <SimpleItem key={"frm-SOURCE_DATE_DELAI"} dataField={"SOURCE_DATE_DELAI"} editorType='dxRadioGroup' editorOptions={dateDelaiEditorOptions}>
                                    <Label text='Date de délai'></Label>
                                </SimpleItem>
                                <SimpleItem key={"frm-modifier"} dataField={"modifier"} editorType='dxCheckBox'>
                                    <Label text='Ne pas recalculer le dépôt lorsque la réservation est modifiée'></Label>
                                </SimpleItem>
                                <GroupItem caption='Confirmation de réservation'>
                                    <GroupItem alignItemLabels={false}>
                                        <SimpleItem
                                            key={"frm-AFFICHER_NOTE_RESERVATION"}
                                            editorOptions={{
                                                text: "Afficher la note de réservation dans l'impression de la confirmation",
                                            }}
                                            label={{visible: false}}
                                            dataField={"AFFICHER_NOTE_RESERVATION"} editorType='dxCheckBox'>
                                        </SimpleItem>
                                        <SimpleItem
                                            key="frm-AFFICHER_NO_MEMBRE_CONFIRMATION"
                                            dataField="AFFICHER_NO_MEMBRE_CONFIRMATION"
                                            editorType="dxCheckBox"
                                            editorOptions={{
                                                text: "Afficher le numéro de membre du client dans l'impression de la confirmation",
                                            }}
                                            label={{visible: false}}
                                        />
                                        <SimpleItem
                                            key="frm-CACHER_DATE_DEPART_CONFIRMATION"
                                            dataField="CACHER_DATE_DEPART_CONFIRMATION"
                                            editorType="dxCheckBox"
                                            editorOptions={{
                                                text: "Cacher la date de départ dans l'impression de la confirmation",
                                            }}
                                            label={{visible: false}}
                                        />
                                        <SimpleItem
                                            key="frm-CACHER_FRAIS_SERVICE_CONF_RESER"
                                            dataField="CACHER_FRAIS_SERVICE_CONF_RESER"
                                            editorType="dxCheckBox"
                                            editorOptions={{
                                                text: "Cacher les frais de services",
                                            }}
                                            label={{visible: false}}
                                        />
                                        <SimpleItem
                                            key="frm-CACHER_HEURES_ENTETE_CONFIRMATION"
                                            dataField="CACHER_HEURES_ENTETE_CONFIRMATION"
                                            editorType="dxCheckBox"
                                            editorOptions={{
                                                text: "Cacher les heures d'arrivées et de départs de l'en-tête lors de l'impression de la confirmation",
                                            }}
                                            label={{visible: false}}
                                        />
                                        <SimpleItem
                                            key="frm-CACHER_PAIEMENTS_CONFIRMATION_RESERVATION"
                                            dataField="CACHER_PAIEMENTS_CONFIRMATION_RESERVATION"
                                            editorType="dxCheckBox"
                                            editorOptions={{
                                                text: "Cacher les paiements des clients sur la confirmation",
                                            }}
                                            label={{visible: false}}
                                        />
                                        <SimpleItem
                                            key="frm-IMPRIMER_OCCUPANTS_RPT_CONF_RESERV"
                                            dataField="IMPRIMER_OCCUPANTS_RPT_CONF_RESERV"
                                            editorType="dxCheckBox"
                                            editorOptions={{
                                                text: "Imprimer un feuillet pour les occupants",
                                            }}
                                            label={{visible: false}}
                                        />
                                        <SimpleItem
                                            key="frm-INCLURE_TAXES_PRIX_UNITAIRE_CONFIRMATION_RESERVATION"
                                            dataField="INCLURE_TAXES_PRIX_UNITAIRE_CONFIRMATION_RESERVATION"
                                            editorType="dxCheckBox"
                                            editorOptions={{
                                                text: "Inclure le montant des taxes dans les prix unitaires de la confirmation",
                                            }}
                                            label={{visible: false}}
                                        />
                                        <SimpleItem key={"frm-NOMBRE_COPIES_CONFIRMATION"} dataField={"NOMBRE_COPIES_CONFIRMATION"} editorOptions={spinEditorOptions}>
                                            <Label text="Nombre de copies par défaut pour l'impression des confirmations"></Label>
                                        </SimpleItem>
                                        <SimpleItem key={"frm-NOMBRE_COPIES_FICHE_RESERVATION"} dataField={"NOMBRE_COPIES_FICHE_RESERVATION"} editorOptions={spinEditorOptions}>
                                            <Label text="Nombre de copies par défaut pour l'impression des fiches de réservations"></Label>
                                        </SimpleItem>
                                    </GroupItem>
                                </GroupItem>
                                <GroupItem caption='Paramètres généraux'>
                                    <SimpleItem key={"frm-ACTIVITE_RESERVATION_DEFAUT"} dataField={"ACTIVITE_RESERVATION_DEFAUT"} editorOptions={activiteEditorOption}>
                                        <Label text="Activité par défaut"></Label>
                                    </SimpleItem>
                                    <SimpleItem key={"frm-DATE_DEBUT_ENVOI_SOMTAB"} dataField={"DATE_DEBUT_ENVOI_SOMTAB"} editorType='dxDateBox' editorOptions={dateEnvoieEditorOptions}>
                                        <Label text="Date d'envoi pour les statistiques Somtab"></Label>
                                    </SimpleItem>
                                    <SimpleItem key={"frm-COULEUR_GROUPE_ENTETE_RESERVATION"} dataField={"COULEUR_GROUPE_ENTETE_RESERVATION"} editorType='dxColorBox' editorOptions={colorEditorOptions}>
                                        <Label text="Couleur des en-têtes de groupes de réservations"></Label>
                                    </SimpleItem>
                                    <SimpleItem key={"frm-COULEUR_GROUPE_DETAIL_RESERVATION"} dataField={"COULEUR_GROUPE_DETAIL_RESERVATION"} editorType='dxColorBox' editorOptions={colorEditorOptions}>
                                        <Label text="Couleur des détails de groupes de réservations"></Label>
                                    </SimpleItem>

                                    <GroupItem alignItemLabels={false}>
                                        <SimpleItem
                                            key={"frm-AFFICHER_DOCUMENT_RECU_RESERVATION"}
                                            editorOptions={{
                                                text: "Afficher la case à cocher 'Document reçu' dans les réservations",
                                            }}
                                            label={{visible: false}}
                                            dataField={"AFFICHER_DOCUMENT_RECU_RESERVATION"} editorType='dxCheckBox'>
                                        </SimpleItem>
                                        <SimpleItem
                                            key={"frm-AFFICHER_DEVISE_RESERVATION"}
                                            editorOptions={{
                                                text: "Afficher la devise dans les réservations",
                                            }}
                                            label={{visible: false}}
                                            dataField={"AFFICHER_DEVISE_RESERVATION"} editorType='dxCheckBox'>
                                        </SimpleItem>
                                        <SimpleItem
                                            key={"frm-AFFICHER_CODE_CLIENT_LISTE_CLIENT"}
                                            editorOptions={{
                                                text: "Afficher le code du client dans la liste des clients",
                                            }}
                                            label={{visible: false}}
                                            dataField={"AFFICHER_CODE_CLIENT_LISTE_CLIENT"} editorType='dxCheckBox'>
                                        </SimpleItem>
                                        <SimpleItem
                                            key={"frm-AFFICHER_NO_MEMBRE_CONFIRMATION"}
                                            editorOptions={{
                                                text: "Afficher le nom du cosignataire sur les confirmations de réservations et factures de réservations",
                                            }}
                                            label={{visible: false}}
                                            dataField={"AFFICHER_NO_MEMBRE_CONFIRMATION"} editorType='dxCheckBox'>
                                        </SimpleItem>
                                        <SimpleItem
                                            key={"frm-AFFICHER_INFO_MEMBRE_RECHERCHE_CLIENT"}
                                            editorOptions={{
                                                text: "Afficher les informations de membres dans la liste des clients",
                                            }}
                                            label={{visible: false}}
                                            dataField={"AFFICHER_INFO_MEMBRE_RECHERCHE_CLIENT"} editorType='dxCheckBox'>
                                        </SimpleItem>
                                        <SimpleItem
                                            key={"frm-IMPRIMER_FICHE_RESERVATION"}
                                            editorOptions={{
                                                text: "Afficher un bouton pour imprimer une fiche de réservation personnalisable",
                                            }}
                                            label={{visible: false}}
                                            dataField={"IMPRIMER_FICHE_RESERVATION"} editorType='dxCheckBox'>
                                        </SimpleItem>
                                        <SimpleItem
                                            key={"frm-DECORTIQUER_AUTO_NOUVELLE_RESERVATION"}
                                            editorOptions={{
                                                text: "Décortiquer automatiquement les détails lors d'une nouvelle réservation par le calendrier",
                                            }}
                                            label={{visible: false}}
                                            dataField={"DECORTIQUER_AUTO_NOUVELLE_RESERVATION"} editorType='dxCheckBox'>
                                        </SimpleItem>
                                    </GroupItem>
                                </GroupItem>
                            </GroupItem>
                        </Form>
                    </TabItem>
                    <TabItem title="Système"><FormSysteme formData={selectedReservation || {} as ILangue}/></TabItem>
                </FormListBaseTab> : null}
        </FormListBase>
    );
}